import React, { useState } from 'react';
import ChatInputBar from '../components/chat/ChatInputBar';

const TestInputBar = () => {
  const [inputMessage, setInputMessage] = useState('');

  const handleSendMessage = (msg) => {
    alert(`📨 Message sent: "${msg}"`);
  };

  return (
    <div style={{ padding: '2rem', background: '#f0f4f9', minHeight: '100vh' }}>
      <h2 style={{ textAlign: 'center' }}>🧪 Chat Input Bar Test</h2>
      <div style={{ maxWidth: '600px', margin: '2rem auto' }}>
        <ChatInputBar
          inputMessage={inputMessage}
          setInputMessage={setInputMessage}
          handleSendMessage={handleSendMessage}
        />
      </div>
    </div>
  );
};

export default TestInputBar;


